// config
import { config } from "config/config";

const getMaintainanceData = async () => {
  try {
    const resp: any = await fetch(config.underMaintainanceURL);
    const response: any = await resp.json();
    return response;
  } catch {
    return null;
  }
};

export { getMaintainanceData };
